<!-- @format -->

<hmf-checkbox
	class="compare-checkbox hmf-pt-xxs hmf-pb-xxxs"
	[label]="'Compare'"
	[ariaLabel]="checked() ? 'Selected for comparison' : 'Select for comparison'"
	[checked]="checked()"
	(keydown.tab)="tabPressed.emit()"
	(click)="onCompareChange($event)">
</hmf-checkbox>
